import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { Worksheet, WorksheetItem, WorksheetQuery, WorksheetService } from '@fgb/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OwlCarouselSettings } from 'src/app/shared/utilities/owl-carousel-settings';

@Component({
  selector: 'fgb-worksheet-list-carousel',
  templateUrl: './worksheet-list-carousel.component.html',
  styleUrls: ['./worksheet-list-carousel.component.scss'],
})
export class WorksheetListCarouselComponent implements OnInit, OnDestroy {
  @Input() colOverride: string = '';
  @Input() isRallyCap = false;
  @Input() videoHeight: string;
  isList: boolean = true;
  worksheetItems: { worksheetId: number; item: WorksheetItem }[];

  private _destroyed$ = new Subject<void>();

  customOptions: OwlOptions = {
    autoHeight: true,
    autoWidth: true,
    margin: OwlCarouselSettings.Margin,
    autoplay: OwlCarouselSettings.Autoplay,
    autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
    autoplaySpeed: OwlCarouselSettings.AutoplaySpeed,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: { items: 1 },
      740: { items: 2 },
      900: { items: 3 },
    },
    dots: true
  };

  constructor(private worksheetService: WorksheetService, private worksheetQuery: WorksheetQuery, private router: Router) {}

  ngOnInit() {
    const currentUrl = this.router.url.replace('/', '').split('?')[0];

    this.worksheetQuery
      .getWorksheetByRoute(currentUrl)
      .pipe(takeUntil(this._destroyed$))
      .subscribe((w) => {
        this.worksheetItems = w.map((wg: Worksheet) => wg.Items.map((i) => ({ worksheetId: wg.WorksheetId, item: i }))).flat();
      });

    if (!this.worksheetQuery.hasRoute(currentUrl)) {
      this.worksheetService.fetchWorksheetByRoute(currentUrl).toPromise();
    }
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
